/**
 * Enum for Profile type values.
 * @readonly
 * @enum {number}
 */
export enum EProfileType {
  NONE = 0,
  PREPAID = 1,
  POSTPAID = 2,
  HYBRID = 3,
  CORPORATE_POSTPAID = 6,
  CORPORATE_HYBRID = 7,
  MODEM_PREPAID = 8,
  MODEM_POSTPAID = 16,
  IFI_PREPAID = 255,
  IFI = 256,
  POSTPAID_FU = 264,
  HYBRID_FU = 265,
  PREPAID_FTU = 266,
  MODEM_PREPAID_FTU = 267
}
